export default (): void => {
  document.querySelectorAll('.dca-block__choice').forEach((choice) => {
    const input = choice.querySelector<HTMLInputElement>('input[type="radio"]')
    choice.addEventListener('click', () => {
      if (!input || input?.disabled) {
        return
      }
      input.checked = true
      if ('createEvent' in document) {
        const evt = document.createEvent('HTMLEvents')
        evt.initEvent('change', false, true)
        input.dispatchEvent(evt)
      } else {
        // @ts-expect-error to check later if still needed
        input.fireEvent('onchange')
      }
    })
    input?.addEventListener('change', () => {
      document.querySelectorAll('.dca-block__choice').forEach((otherChoice) => {
        otherChoice.classList.remove('dca-block__choice--selected')
      })
      choice.classList.add('dca-block__choice--selected')
    })
  })
}
